import { ChangeDetectionStrategy, Component, ElementRef, inject, model, TemplateRef, viewChild, ViewContainerRef } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonDirective, IconDirective, PopoverService } from 'shared/ui-common';

import { ResourceTag } from '@treetop/shared/model';
import { ResourceTagListComponent, AddResourceTagsComponent } from '@treetop/shared/tt-resource-tags';

@Component({
  selector: 'tt-sidebar-resource-tags',
  standalone: true,
  templateUrl: './sidebar-resource-tags.component.html',
  styleUrls: ['./sidebar-resource-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'data-testid': 'tt-sidebar-resource-tags',
  },
  imports: [MatIcon, ButtonDirective, IconDirective, TranslocoModule, AddResourceTagsComponent, ResourceTagListComponent],
})
export class SidebarResourceTagsComponent {
  private readonly popoverService = inject(PopoverService);
  private readonly viewContainerRef = inject(ViewContainerRef);

  public selectedTags = model<ResourceTag[]>([]);

  private triggerButton = viewChild<ElementRef>('triggerButton');
  private addResourceTagsTemplate = viewChild<TemplateRef<unknown>>('addResourceTagsTemplate');

  protected openDropdown(event: MouseEvent): void {
    event.stopPropagation();

    const triggerEl = this.triggerButton();
    const template = this.addResourceTagsTemplate();
    if (!triggerEl || !template) return;

    this.popoverService.open(
      template,
      triggerEl.nativeElement,
      { panelClass: 'tt-tag-dropdown-panel', hasBackdrop: false },
      this.viewContainerRef,
    );
  }

  protected handleTagsChanged(tags: ResourceTag[]): void {
    this.selectedTags.set(tags);
  }

  protected removeTag(tag: ResourceTag): void {
    this.selectedTags.update((tags) => tags.filter((t) => t.id !== tag.id));
  }
}
